const styles = {
  root: {
    pb: 1,
    display: 'block',
    textAlign: 'left',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    border: 1,
    borderColor: 'background.border',
    borderRadius: 0,
    '&:hover': {
      boxShadow: 2,
    },
    textDecoration: 'none!important',
    paddingBottom: 1,
    minHeight: '304px',
    '&.withoutHitch': {
      minHeight: '280px!important',
    },
  },

  titleCar: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    marginBottom: 0,
  },
  hold: {
    display: 'flex',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0, 0.8)',
    zIndex: 10,
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    '.MuiTypography-body1': {
      color: 'text.white',
      ml: 1,
    },
  },

  displayBlock: { display: 'inline-block' },
  displayFlex: { display: 'inline-flex' },
  priceContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 0.5,
    wrap: 'nowrap',
    maxWidth: { xs: '100%', sm: '75%' },
    '& .MuiTypography-root': {
      mr: 1,
    },
  },
  bullAttributes: { marginLeft: 3 },

  price: (color) => ({
    '&.MuiTypography-h3': {
      color,
    },
  }),

  peopleAction: (color) => ({
    ml: 0.7,
    '&.MuiTypography-strong': {
      color,
    },
  }),

  discount: {
    backgroundColor: 'background.grey450',
    padding: '3px',
    '&.MuiTypography-quote': {
      color: 'common.purple',
    },
  },

  alertText: {
    '&.MuiTypography-h3': {
      color: 'text.alert',
    },
  },
  payments: {
    color: 'primary.main!important',
    whiteSpace: 'nowrap',
    textDecoration: 'underline!important',
    fontWeight: 'bold',
  },

  imageSwiper: {
    height: 130,
    margin: '0 auto',
    position: 'relative',
    '.swiper-button-disabled': {
      display: 'none',
    },
    '& .swiper': {
      position: 'static',
      height: '100%',
      overflow: 'hidden',
    },
    '& .swiper-wrapper': {
      height: '100%',
      width: '100%',
      position: 'relative',
      // z-index: 1;
      display: 'flex',
      transitionProperty: 'transform',
      boxSizing: 'content-box',
      // paddingTop: '20px',
    },
    '& .swiper-slide': {
      // '&.swiper-slide-active': {
      //   '& > span:nth-of-type(1)': {
      //     borderTopLeftRadius: 8,
      //   },
      // },
      // '&.swiper-slide-next': {
      //   '& > span:nth-of-type(1)': {
      //     borderTopRightRadius: 8,
      //   },
      // },
      '&:nth-of-type(odd)': {
        marginRight: '4px',
      },
      position: 'relative',
      flexShrink: '0',
      width: 'calc(50% - 2px)',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .swiper-button-next': {
      top: '35%!important',
      right: 10,
      mt: 0,
    },

    '& .swiper-button-prev': {
      top: '35%!important',
      mt: 0,
      left: 10,
    },
    '&.mt': {
      '& .swiper-wrapper': {
        paddingTop: '0px!important',
      },
    },
  },
  button360: {
    backgroundColor: (theme) => `${theme.palette.background.default}!important`,
    color: (theme) => `${theme.palette.secondary.main}!important`,
    position: 'absolute',
  },
  noImage: {
    border: 1,
    borderColor: 'divider',
    height: 100,
    position: 'relative',
    marginBottom: 1,
  },

  sellerTag: {
    width: '100%',
    color: 'secondary.main',
    height: 'unset',
    padding: 0,
    marginLeft: 0,
    border: 'none',
    '& .MuiIconButton-root': {
      background: 'unset',
      padding: 0,
    },
    '& .MuiIconButton-root svg': {
      width: 18,
      height: 18,
      color: 'secondary.main',
    },
  },

  monthlyInstallments: {
    lineHeight: 0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.main',
    borderRadius: 0.5,
    padding: 0.5,
    marginBottom: 0.5,
    '&:hover': {
      backgroundColor: '#B3E4EF',
    },
  },

  subscribe: {
    lineHeight: 0,
    border: '1px solid #F2F2F2',
    padding: 0.5,
    marginBottom: 0.5,
  },

  tiles: {
    '.MuiGrid-item': {
      '.Tile-root': {
        span: {
          py: '2px',
          px: '6px',
          fontSize: 11,
        },
        '.Tile-icon': {
          px: 0,
        },
      },
    },
  },

  tagsBanner: {
    position: 'absolute',
    display: 'block',
    top: -1,
    left: 0,
    right: 0,
    zIndex: 99,
    paddingX: 0.5,
    backgroundColor: '#135FC4',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#fff',
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    '&.hold': {
      backgroundColor: 'background.grey800',
    },
    '&.easy': {
      backgroundColor: 'common.secondaryEasy',
      '& span': {
        color: '#000!important',
        marginRight: 0.5,
      },
    },
  },

  suscriptionText: {
    '& span': {
      color: '#fff!important',
      marginRight: 0.5,
    },
  },
  showCreditContainer: {
    minHeight: 22,
  },

  sellerType: {
    '& svg': {
      marginRight: 0.5,
    },
  },

  locationText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& svg': {
      marginRight: 0.5,
    },

  },

  breakSpace: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: 1,
    marginTop: 1,
    '& span': {
      paddingX: 0.5,
    },
  },

  vehicleInfoContainer: {
    paddingX: (theme) => `${theme.spacing(3)}!important`,
    '&.minHeight': {
      // minHeight: '105px',
    },

  },

  sellerContainer: {
    marginX: 3,
    // marginTop: 0,
    // position: 'absolute',
  },
}

export default styles
